import React, {FC} from "react"

import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import {useTheme} from "@irati/ui/src/global/useTheme"
import intercom from "@irati/utils/intercom"
import {Body} from "@irati/ui/src/Typography"
import Link from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import EmptyWidget from "./EmptyWidget"

interface Props extends InjectIntl {}

const MaximiseUsageWidget: FC<Props> = ({formatMessage}) => {
  const theme = useTheme()
  return (
    <EmptyWidget
      title="admin.components.dashboard.reporting.maximiseUsage.title"
      img="admin.components.dashboard.reporting.valuesCelebrationsWidget.img"
      buttonText="admin.components.dashboard.reporting.maximiseUsage.button"
      onClick={() => intercom.addCustomMessage("")}>
      <Flex alignItems="center" gap={1}>
        <Body paddingTop={1} small color={theme.colors.greys.white} maxWidth="100%">
          <FormattedMessage id="admin.components.dashboard.reporting.maximiseUsage.body" />
        </Body>
        <Link
          inverted
          href={formatMessage({id: "admin.components.dashboard.reporting.maximiseUsage.link.href"})}
          target="_blank"
          rel="noopener noreferrer">
          <FormattedMessage id="admin.components.dashboard.reporting.maximiseUsage.link.text" />
        </Link>
      </Flex>
      <Body paddingTop={1} small color={theme.colors.greys.white} maxWidth="100%">
        <FormattedMessage id="admin.components.dashboard.reporting.maximiseUsage.body2" />
      </Body>
    </EmptyWidget>
  )
}

export default injectIntl(MaximiseUsageWidget)
